export default class ResourceApiModel {
  constructor(rawModel) {
    this.BusinessUnitKey = rawModel?.BusinessUnitKey || null
    this.Key = rawModel?.Key || null
    this.Description = rawModel?.Description || null
    this.Slug = rawModel?.Slug || null
    this.Abbreviation = rawModel?.Abbreviation || null
    this.Color = rawModel?.Color || null
    this.Capacity = rawModel?.Capacity || null
    this.TimeslotMinutes = rawModel?.TimeslotMinutes || null
    this.Icon = rawModel?.Icon || null
    this.UseAsFilter = rawModel?.UseAsFilter || null
    this.Exclusive = rawModel?.Exclusive || null
    this.ShowOnScheduler = rawModel?.ShowOnScheduler || null
    this.OneTimeLeadIn = rawModel?.OneTimeLeadIn || null
    this.PermanentTimeLeadIn = rawModel?.PermanentTimeLeadIn || null
    this.ResetTime = rawModel?.ResetTime || null
    this.ResetTimeType = rawModel?.ResetTimeType || null
    this.IgnoreTimeslotDuration = rawModel?.IgnoreTimeslotDuration || null
    this.DefaultProductKey = rawModel?.DefaultProductKey || null
    this.TeamSize = rawModel?.TeamSize || null
    this.Priority = rawModel?.Priority || null
    this.AllowOrderChanges = rawModel?.AllowOrderChanges || null
    this.ResourceType = rawModel?.ResourceType || null // 'NotSet' | 'Normal' | 'SubResource' | 'ResourceGroup'
    this.ParentResourceKey = rawModel?.ParentResourceKey || null
    this.ChildResources = rawModel?.ChildResources?.map(x => new ChildResourceApiModel(x)) || null
    this.ExternalType = rawModel?.ExternalType || null // [ NotSet, CardConnect, Clubspeed, ERP, PublicApi, Gifty, Stripe, StripeTest, Till, Voucherify, Zapier, Zendesk, Innomeer, ExternalPaymentMethod, Briq, Lightspeed, Fast, Entertainment501 ]
    this.ExternalResources = rawModel?.ExternalResources || null
    this.OfflineProductKey = rawModel?.OfflineProductKey || null
    this.MetaData = rawModel?.MetaData || null
    this.Settings = rawModel?.Settings || null
    this.SupportedProductDurationTypes = rawModel?.SupportedProductDurationTypes || null // [ NoDuration, PerParticipant, FixedDuration, ParallelScheduling ]
    this.IsActive = typeof rawModel?.IsActive === 'boolean' ? rawModel.IsActive : null
    this.AllowsScheduling =
      typeof rawModel?.AllowsScheduling === 'boolean' ? rawModel.AllowsScheduling : null
    this.ProductsAreDefaultScheduled =
      typeof rawModel?.ProductsAreDefaultScheduled === 'boolean'
        ? rawModel.ProductsAreDefaultScheduled
        : null
    this.DefaultTimeslotDuration = rawModel?.DefaultTimeslotDuration || null
  }
}

class ChildResourceApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key || null
    this.Name = rawModel?.Name || null
    this.ShowOnScheduler = rawModel?.ShowOnScheduler || null
    this.Priority = rawModel?.Priority || null
    this.Abbreviation = rawModel?.Abbreviation || null
    this.Color = rawModel?.Color || null
    this.Icon = rawModel?.Icon || null
  }
}
